import React, { useState, useEffect } from "react";
import { Input, Text } from "@fragments";
import { Person as PersonIcon } from "@mui/icons-material";
import { UserAvatar } from "@components/Community";
import api from "@helpers/api";

export default function LessonOwner({ value, onChange, community }) {
    const [owners, setOwners] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCommunityAdmins();
    }, []);

    useEffect(() => {
        if (owners.length > 0 && !value) {
            const firstOwner = owners[0];
            onChange?.(firstOwner.id);
        }
    }, [owners, value, onChange]);

    const fetchCommunityAdmins = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("community/member/permission?permission=admin&community=" + community);
            setOwners([...data]);
        } catch (error) {
            console.error("Error fetching community admins:", error);
            setOwners([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return null;

    if (owners.length === 0) return null;

    const selectedOwner = owners.find(o => o.id === value);

    const options = owners.map(owner => ({
        label: owner.username,
        value: owner.id,
        icon: <UserAvatar user={owner} size={24} />
    }));

    return (
        <>
            <Text.h5
                left={<PersonIcon />}
                value="Proprietário do vídeo"
                className="mb-1"
            />
            <Input.Select
                value={value}
                onInput={onChange}
                options={options}
                start={selectedOwner ? <UserAvatar user={selectedOwner} size={24} /> : <PersonIcon />}
            />
        </>
    );
}
